import { useEffect } from 'react';
import angular from 'angular';
import { useCurrentStateAndParams } from '@uirouter/react';

import { StateManager } from '@/portainer/services/types';

import { PageHeader } from '@@/PageHeader';

import { useSettings } from '../queries';
import { Settings } from '../types';
import { isBE } from '../../feature-flags/feature-flags.service';

import { ApplicationSettingsPanel } from './ApplicationSettingsPanel';
import { BackupSettingsPanel } from './BackupSettingsView';
import { HelmCertPanel } from './HelmCertPanel';
import { HiddenContainersPanel } from './HiddenContainersPanel/HiddenContainersPanel';
import { KubeSettingsPanel } from './KubeSettingsPanel';
import { SSLSettingsPanelWrapper } from './SSLSettingsPanel/SSLSettingsPanel';
import { ExperimentalFeatures } from './ExperimentalFeatures';
import { AdditionalFunctionality } from './AdditionalFunctionality';
import { SupportPanel } from './SupportPanel/SupportPanel';

export function SettingsView() {
  const settingsQuery = useSettings();
  const { params } = useCurrentStateAndParams();

  useEffect(() => {
    // window.location.hash will get everything after the hashbang
    // the regex will match the the content after last hash and finds the
    // element with the id that matches the hash
    if (settingsQuery.data) {
      const regEx = /#!.*#(.*)/;
      const match = window.location.hash.match(regEx);
      if (match && match[1]) {
        document.getElementById(match[1])?.scrollIntoView();
      }

      // Handle section parameter for direct navigation
      if (params.section === 'additional-functionality') {
        setTimeout(() => {
          document.getElementById('additional-functionality')?.scrollIntoView();
        }, 100);
      }
      if (params.section === 'experimental-features') {
        setTimeout(() => {
          document.getElementById('experimental-features')?.scrollIntoView();
        }, 100);
      }
    }
  }, [settingsQuery.data, params.section]);

  return (
    <>
      <PageHeader title="Settings" breadcrumbs="Settings" reload />

      <div className="mx-4 py-4 space-y-4">
        {settingsQuery.data && (
          <>
            <ApplicationSettingsPanel
              onSuccess={handleSuccess}
              settings={settingsQuery.data}
            />

            <KubeSettingsPanel settings={settingsQuery.data} />
          </>
        )}

        <HelmCertPanel />

        <SSLSettingsPanelWrapper />

        {isBE && <AdditionalFunctionality />}

        {isBE && <ExperimentalFeatures />}

        <HiddenContainersPanel />

        <BackupSettingsPanel />

        <SupportPanel />
      </div>
    </>
  );
}

function handleSuccess(settings: Settings) {
  // to sync "outside state" - for angularjs
  // this is a hack, but it works
  // state manager should be replaced with a non angular solution, maybe using zustand
  const $injector = angular.element(document).injector();
  $injector.invoke(
    /* @ngInject */ (StateManager: StateManager) => {
      StateManager?.updateLogo(settings.LogoURL);
      StateManager?.updateSnapshotInterval(settings.SnapshotInterval);
      StateManager?.updateEnableTelemetry(settings.EnableTelemetry);
    }
  );
}
